import apiClient from './client';

export interface Category {
    id: number;
    name: string;
    name_ar: string;
    slug: string;
    icon?: string;
    image?: string;
}

export interface ProductVariant {
    id: number;
    sku: string;
    name_suffix: string;
    price: string;
    effective_price: string;
}

export interface ProductImage {
    id: number;
    image: string;
    alt_text: string;
    is_primary: boolean;
}

export interface ProductTemplate {
    id: number;
    name: string;
    name_ar: string;
    description: string;
    description_ar: string;
    base_price: string;
    category: number;
    category_name: string;
    category_name_ar?: string;
    variants: ProductVariant[];
    images: ProductImage[];
}

export const catalogApi = {
    getCategories: async () => {
        const { data } = await apiClient.get<any>('/catalog/categories/');
        return data.results ? data.results : data;
    },

    getProducts: async (params?: Record<string, string>) => {
        const { data } = await apiClient.get<{ count: number, results: ProductTemplate[] }>('/catalog/products/', { params });
        return data;
    },

    getProduct: async (id: string | number) => {
        const { data } = await apiClient.get<ProductTemplate>(`/catalog/products/${id}/`);
        return data;
    }
};
